module.exports = __webpack_public_path__ + "static/media/cross_platform_app_development.1ee6ed77.svg";